import { HOC } from '../../util/types';
import React from 'react';

// prettier-ignore
export const withWrapper = (WrapperComponent: React.ComponentType): HOC => (InnerComponent) => (props) => (
    <WrapperComponent>
        <InnerComponent {...props} />
    </WrapperComponent>
);
